const comments = [
  {
    name: '影视达人小张',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20man%20with%20warm%20smile%2C%20clean%20studio%20lighting%2C%20modern%20casual%20style%2C%20friendly%20expression%2C%20headshot%20photography%20with%20soft%20natural%20background&width=120&height=120&seq=avatar-01&orientation=squarish',
    text: '片多多影视真心好用！画质超清晰，而且完全不卡顿，现在已经是我每天必刷的观影平台了。片多多免费观看太良心了！',
    rating: 5,
    time: '3天前',
  },
  {
    name: '追剧小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20gentle%20smile%2C%20clean%20studio%20lighting%2C%20modern%20casual%20style%2C%20warm%20expression%2C%20headshot%20photography%20with%20soft%20natural%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    text: '在片多多上追完了好几部热播剧，高清不卡的体验真的棒！更新速度也很快，新剧上线基本同步，强烈推荐！',
    rating: 5,
    time: '5天前',
  },
  {
    name: '电影爱好者老李',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20middle-aged%20Chinese%20man%20with%20confident%20expression%2C%20clean%20studio%20lighting%2C%20modern%20casual%20style%2C%20friendly%20look%2C%20headshot%20photography%20with%20soft%20natural%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    text: '片多多影视片库太全了！从老电影到最新大片都有，而且片多多高清免费，没有任何套路。画质音效都很棒！',
    rating: 5,
    time: '1周前',
  },
  {
    name: '动漫迷阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20teenage%20Chinese%20boy%20with%20enthusiastic%20smile%2C%20clean%20studio%20lighting%2C%20modern%20casual%20style%2C%20energetic%20expression%2C%20headshot%20photography%20with%20soft%20natural%20background&width=120&height=120&seq=avatar-04&orientation=squarish',
    text: '作为一个重度动漫迷，片多多影视的动漫资源真的很丰富！日漫国漫都有，片多多高清不卡，看番体验一流！',
    rating: 4,
    time: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">用户好评</h2>
            <p className="mt-3 text-sm text-foreground-500">看看大家怎么说</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {comments.map((c, i) => (
              <div key={i} className="bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <i key={j} className={`ri-star-fill text-xs ${j < c.rating ? 'text-primary-500' : 'text-background-300'}`}></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">&ldquo;{c.text}&rdquo;</p>
                <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200/60">
                  <img src={c.avatar} alt={c.name} className="w-9 h-9 rounded-full object-cover" />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{c.name}</p>
                    <p className="text-xs text-foreground-500">{c.time}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}